module.exports = __webpack_public_path__ + "static/media/castlebrook.690c2e00.png";